export const GET_HOST_VIDEO_CALL_HISTORY = "GET_HOST_VIDEO_CALL_HISTORY";
